import React from 'react';
import { useSearchParams } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux';
import { actions as uiActions } from '@/reducers/ui';

import Button, {
  BUTTON_WIDTH,
  BUTTON_TYPE,
} from '@gc-npm/components.button';
import CustomLink from '@gc-npm/components.custom-link';
import TextInfo, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import { COLORS } from '@gc-npm/utils.enums.colors';
import { SCREEN_TYPES } from '@/utils/constants';

export const RECOMENDATOR_BANNER_MODES = {
  BANNER: 'banner',
  ACTIONS: 'actions',
};
const URL_CONFIG = '/fibra-y-movil/configurador';
export const RecomendatorBanner = ({ mode, screenType }) => {
  const searchParams = useSearchParams()
  const context = useSelector((state) => state.main.context);
  const queryString = searchParams.toString()
  const urlToGo = `${URL_CONFIG}?${queryString}`;
  const dispatch = useDispatch();
  const textos = useSelector((state) => state.recomendator?.data?.textos?.cardConfigurarPack);
  const tagginInfo = {
    componentContent: textos?.buttonText,
    componentName: 'return-configurador',
    componentProduct: '',
    componentVariation: 'all',
  }
  return (
    <div className={`RecomendatorBanner  ${mode === RECOMENDATOR_BANNER_MODES.BANNER ? 'backGroundImage' : ''}`}>
      {mode === RECOMENDATOR_BANNER_MODES.BANNER && (
        <div className="wrapper container">
          <div className="banner">
            <div className="bannerText">
              <TextInfo
                text={textos?.title}
                size={TEXT_SIZE.T5}
                color={TEXT_COLOR.WHITE}
                fontType={TEXT_FONT_WEIGHT.BOLD}
                align={TEXT_ALIGN.CENTER}
              />
            </div>
            <div className="bannerButton">
              <Button
                label={textos?.buttonText}
                href={urlToGo}
                type={BUTTON_TYPE.SECONDARY}
                width={screenType === SCREEN_TYPES.MOBILE ? BUTTON_WIDTH.FULL : BUTTON_WIDTH.MEDIUM}
                taggingInfo={{
                  ...tagginInfo,
                  componentName: `link-${tagginInfo.componentName}`,
                }}
              />
            </div>
          </div>
        </div>
      )}

      {mode === RECOMENDATOR_BANNER_MODES.ACTIONS && (
        <div className="buttonActions container">
          <Button
            label="Hacer nueva selección"
            onClick={() => {
              if (typeof window !== 'undefined') {
                sessionStorage.removeItem('selection');
              }
              const env = context.environment?.name;
              let prefix = '';
              if (env === 'dev_ssr') {
                prefix = '/develop'
              } else if (env === 'qa_ssr') {
                prefix = '/qa'
              }
              const url2go = `${prefix}/fibra-y-movil/`;
              dispatch(uiActions.navigate2Url({ url: url2go }))
              // router.push(`/fibra-y-movil/`, undefined, { shallow: true });
            }}
            type={BUTTON_TYPE.SECONDARY}
            width={BUTTON_WIDTH.MEDIUM}
            taggingInfo={{
              ...tagginInfo,
              componentProduct: 'Hacer nueva selección',
              componentName: 'button-reset-recomendacion',
            }}
          />
          <CustomLink
            ariaLabel={textos?.buttonText}
            href={urlToGo}
            taggingInfo={{
              ...tagginInfo,
              componentName: `button-${tagginInfo.componentName}`,
            }}
          >
            <div>
              <TextInfo
                text={textos?.buttonText}
                size={TEXT_SIZE.SUBTITLE1}
                color={TEXT_COLOR.MOVISTAR_BLUE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          </CustomLink>
        </div>
      )}
      <style jsx>
        {`
          .RecomendatorBanner {
            padding: 1rem 0;
            &.backGroundImage {
              background-color: ${COLORS.movistarBlue};
              // background-image: url('https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/fondos/recomendador-banner-desktop.jpg/_jcr_content/renditions/web-movistar-small_reduced.webp');
              // background-size: cover;
              // background-position: center;
            }
            .wrapper {
              .banner {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-evenly;
                .bannerButton{
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  
                }
              }
            }
            .buttonActions {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 1rem;
                flex-wrap: wrap;
            }
          } 
          @media screen and (min-width: 768px) {
            .RecomendatorBanner{
              padding: 1.75rem 0;
            }
          }
          @media screen and (max-width: 768px) {
            .RecomendatorBanner{
               &.backGroundImage {
                // background-image: url('https://prod.adb.col.movistar.es/content/dam/movistar//estaticos/fondos/recomendador-banner-mobile.jpg/_jcr_content/renditions/web-movistar-small_reduced.webp');
              }
              .wrapper{
                .banner{
                  justify-content: center;
                  gap: 0.75rem;
                  .bannerText {
                    width: auto;
                  }
                  .bannerButton {
                    width: 100%;
                  }
                }
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default RecomendatorBanner;
